import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/pages/auth/Login';
import Dashboard from './components/pages/Dashboard';
import AlimentiPersonali from './components/pages/osservatorio/AlimentiPersonali';
import AlimentiPersonaliDettaglio from './components/pages/osservatorio/AlimentiPersonaliDettaglio';
import AlimentiCommerciali from './components/pages/osservatorio/AlimentiCommerciali';
import AlimentiCommercialiDettaglio from './components/pages/osservatorio/AlimentiCommercialiDettaglio';
import DietePersonali from './components/pages/osservatorio/DietePersonali';
import UserManagement from './components/pages/admin/UserManagement';
import ChangePassword from './components/pages/profile/ChangePassword';
import AdminRoute from './components/utils/AdminRoute';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Caricamento...</p>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Caricamento...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
        />
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/alimenti-personali" 
          element={
            <ProtectedRoute>
              <AlimentiPersonali />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/alimenti-personali/dettaglio" 
          element={
            <ProtectedRoute>
              <AlimentiPersonaliDettaglio />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/alimenti-commerciali" 
          element={
            <ProtectedRoute>
              <AlimentiCommerciali />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/alimenti-commerciali/dettaglio" 
          element={
            <ProtectedRoute>
              <AlimentiCommercialiDettaglio />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/diete-personali" 
          element={
            <ProtectedRoute>
              <DietePersonali />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/users" 
          element={
            <AdminRoute>
              <UserManagement />
            </AdminRoute>
          } 
        />
        <Route 
          path="/profile/change-password" 
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppContent />
      </div>
    </AuthProvider>
  );
}

export default App;
